import React, { useEffect, useRef, useState } from "react";
import { useCombinedStore } from "../store";
import Modal from "react-modal";
import api from "../services/api.service";
import * as Styles from "../styles/Order.Modal.styles";
import alfredoIcon from "../assets/alfredo-icon.svg";

const OpencounterOrderModal: React.FC<{
  counter: string;
  isOpen: boolean;
  onRequestClose: (clearField: boolean) => void;
  productsTransfer: any;
}> = ({ counter, isOpen, onRequestClose, productsTransfer }) => {
  const {
    setSubsidiaryDataZustand,
    subsidiaryDataZustand,
    setOrderDataZustand,
    orderDataZustand,
    setMessageZustand,
  } = useCombinedStore();

  const [orderOwnerUuid, setOrderOwnerUuid] = useState("");
  const [emailOptions, setEmailOptions] = useState<
    [{ userEmail: String; userUuid: String }]
  >([{ userEmail: "", userUuid: "" }]);
  const [selectedOrigin, setSelectedOrigin] = useState("directContact");

  const handleSubmit = async () => {
    try {
      const selectedCounter =
        subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodCounters?.find(
          (counterItem: any) => counterItem.itemName === counter
        );
      const openOrderResponse = await api.post(`order`, {
        orderOwnerUuid: orderOwnerUuid,
        period: subsidiaryDataZustand.selectedPdv.selectedPeriod.periodUuid,
        orderType: "PICKUP",
        orderInfo: {
          counterUuid: selectedCounter.itemUuid,
          counterOrigin: selectedOrigin,
        },
      });

      if (productsTransfer) {
        for (const productOrder of productsTransfer) {
          try {
            let productOrderData: {
              orderType: string;
              productUuid: any;
              productPrinted: boolean;
              productCode: string;
              productName: any;
              productPrice: any;
              productDiscount: string;
            } = {
              orderType: `PICKUP`,
              productUuid: productOrder.productUuid,
              productCode: String(productOrder.productCode),
              productPrinted: false,
              productName: productOrder.productName,
              productPrice: Number(productOrder.productPrice.replace(",", ".")),
              productDiscount: "0",
            };

            api.post(
              `addProductOrder/${openOrderResponse.data.order?.orderUuid}`,
              productOrderData
            );


          } catch (error: any) {
            if (error.message === "Network Error") {
              setMessageZustand(
                `Erro ao tentar incluir produto, entre em contato com os administradores do Alfredo da sua unidade.`,
                `error`
              );
            } else {
              setMessageZustand(
                `Erro ao incluir produto: ${error.message}`,
                `error`
              );
            }
          }
        }
      }

      setMessageZustand(
        `Pedido ${openOrderResponse.data.order?.orderCode} aberto com sucesso!`,
        `success`
      );
      onRequestClose(false);
    } catch (error: any) {
      if (error.message === "Network Error") {
        setMessageZustand(
          `Erro ao tentar abrir nova conta, entre em contato com os administradores do Alfredo da sua unidade.`,
          `error`
        );
      } else {
        setMessageZustand(
          `Erro ao abrir uma nova conta: ${error.message}`,
          `error`
        );
      }
    }
  };
  const handleEmailChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    // Atualizar o estado userEmail quando o dropdown for alterado
    const selectedUser = emailOptions.find(
      (userEmail) => userEmail.userEmail === e.target.value
    );
    setOrderOwnerUuid(String(selectedUser?.userUuid));
  };
  const GetUsers = async () => {
    try {
      const response = await api.get("/opsUsers");
      if (response.status !== 200) {
        throw new Error(response.data.message);
      }
      setEmailOptions(response.data);
      setOrderOwnerUuid(response.data[0].userUuid);
    } catch (error: any) {
      console.error("Erro ao buscar os usuários:", error);
    }
  };
  const modalWrapperRef = useRef<HTMLDivElement>(null);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };
  useEffect(() => {
    if (isOpen) {
      GetUsers();
      setTimeout(() => {
        modalWrapperRef.current?.focus();
      }, 500);
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => onRequestClose(true)}
      style={Styles.customStyles}
      contentLabel="Main Modal"
      ariaHideApp={false}
    >
      <Styles.ModalWrapper
        tabIndex={-1}
        ref={modalWrapperRef}
        onKeyDown={handleKeyDown}
      >
        <Styles.CloseButton onClick={() => onRequestClose(true)}>
          &times;
        </Styles.CloseButton>
        <Styles.ModalContent>
          <Styles.ModalHeader
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .buttonsColor
            }
          >
            <Styles.Logo src={alfredoIcon} alt="Alfredo Web OPS" />
            <Styles.ModalTitle>Nova Conta</Styles.ModalTitle>
            <Styles.ModalDescription>{`Informe quem atenderá o balcão`}</Styles.ModalDescription>
          </Styles.ModalHeader>
          <Styles.ModalBody
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .backgroundColor
            }
          >
            <Styles.RowContainer>
              <Styles.FieldContainer>
                <Styles.DropdownInput
                  color={
                    subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                      .buttonsColor
                  }
                >
                  <select onChange={handleEmailChange}>
                    {emailOptions?.map((userEmail: any) => (
                      <option
                        key={userEmail.userUuid}
                        value={userEmail.userEmail}
                      >
                        {userEmail.userEmail}
                      </option>
                    ))}
                  </select>
                  <label>Quem atenderá esta conta?</label>
                </Styles.DropdownInput>
              </Styles.FieldContainer>
            </Styles.RowContainer>
            <Styles.RowContainer>
              <Styles.FieldContainer>
                <Styles.DropdownInput
                  color={
                    subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                      .buttonsColor
                  }
                >
                  <select
                    value={selectedOrigin}
                    onChange={(e) => {
                      setSelectedOrigin(e.target.value);
                    }}
                  >
                    <option value="externalApp">
                      Aplicativo externo (Ifood, Rappi...)
                    </option>
                    <option value="internalApp">
                      Aplicativo interno (Alfredo, Lucco)
                    </option>
                    <option value="directContact">Telefone</option>
                  </select>
                  <label>Qual é a Origem do Cliente?</label>
                </Styles.DropdownInput>
              </Styles.FieldContainer>
            </Styles.RowContainer>
          </Styles.ModalBody>
          <Styles.ModalFooter
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .buttonsColor
            }
          >
            <Styles.Button onClick={() => onRequestClose(true)}>
              Cancelar
            </Styles.Button>
            <Styles.Button onClick={handleSubmit}>Abrir Pedido</Styles.Button>
          </Styles.ModalFooter>
        </Styles.ModalContent>
      </Styles.ModalWrapper>
    </Modal>
  );
};

export default OpencounterOrderModal;
